module.exports = __webpack_public_path__ + "img/customer-a-041.a3230692.png";